import React from 'react'

import * as styles from './sidebar.module.scss'

const IconBase: React.FC = ({ children }) => (
  <svg
    viewBox="0 0 36 36"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.sidebar__icon}
  >
    {children}
  </svg>
)

export const TodayIcon: React.FC = () => (
  <IconBase>
    <g fill="none" fillRule="evenodd" transform="translate(9 7)">
      <path
        className={styles.sidebar__iconSecondary}
        d="M2,0 L17,0 C18.1045695,-2.02906125e-16 19,0.8954305 19,2 L19,20 C19,21.1045695 18.1045695,22 17,22 L2,22 C0.8954305,22 1.3527075e-16,21.1045695 0,20 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
      />
      <g className={styles.sidebar__iconPrimaryGroup}>
        <rect width="15" height="4" x="2" y="3" />
        <rect width="6" height="3" x="2" y="9" />
        <rect width="6" height="1" x="2" y="14" />
        <rect width="6" height="1" x="2" y="16" />
        <rect width="6" height="1" x="2" y="18" />
        <rect width="7" height="10" x="10" y="9" />
      </g>
    </g>
  </IconBase>
)

export const BrowseIcon: React.FC = () => (
  <IconBase>
    <g fill="none" fillRule="evenodd" transform="translate(6 8)">
      <path
        className={styles.sidebar__iconPrimary}
        d="M0,20 L8,16 L8,0.439462566 L8,2.84217094e-14 L0,4 L0,20 Z M16,4 L16,20 L24,16 L24,0 L16,4 Z"
      />
      <polygon
        className={styles.sidebar__iconSecondary}
        points="16 4 8 0 8 16 16 20"
      />
    </g>
  </IconBase>
)

export const ScreensIcon: React.FC = () => (
  <IconBase>
    <g data-test-target="filter">
      <g className={styles.sidebar__iconPrimaryGroup}>
        <path
          d="M0 2c0-.6.4-1 1-1h20c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1H1a1 1 0 0 1-1-1V2z"
          transform="translate(7 15)"
        />
        <path
          d="M0 2c0-.6.4-1 1-1h20c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1H1a1 1 0 0 1-1-1V2z"
          transform="translate(7 7)"
        />
        <path
          d="M0 2c0-.6.4-1 1-1h20c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1H1a1 1 0 0 1-1-1V2z"
          transform="translate(7 23)"
        />
      </g>
      <g className={styles.sidebar__iconSecondaryGroup}>
        <path
          d="M17 4c0 .6-.4 1-1 1h-5a1 1 0 0 1-1-1V1c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v3z"
          transform="translate(7 15)"
        />
        <path
          d="M11 4c0 .6-.4 1-1 1H5a1 1 0 0 1-1-1V1c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v3z"
          transform="translate(7 7)"
        />
        <path
          d="M14 4c0 .6-.4 1-1 1H8a1 1 0 0 1-1-1V1c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v3z"
          transform="translate(7 23)"
        />
      </g>
    </g>
  </IconBase>
)

export const FoliosIcon: React.FC = () => (
  <IconBase>
    <g fill="none" fillRule="evenodd" transform="translate(7 8)">
      <path
        className={styles.sidebar__iconPrimary}
        d="M3,0 L7,0 C7.55228475,0 8,0.44771525 8,1 L8,2 L19,2 C19.5522847,2 20,2.44771525 20,3 L20,7 L2,7 L2,1 C2,0.44771525 2.44771525,0 3,0 Z"
      />
      <rect
        className={styles.sidebar__iconSecondary}
        width="14"
        height="3"
        x="4"
        y="4"
      />
      <path
        className={styles.sidebar__iconPrimary}
        d="M21.0001438,7 C21.5523491,7 22,7.44743167 22,7.9993666 C21.9969649,8.1218208 21.9813679,8.2124911 21.9545336,8.2981969 L20.0048036,17.9930326 C19.9978532,18.5473967 19.5511357,18.9923992 19.0004315,18.9923992 C7.21811296,19.009501 3.23360631,18.9923992 3.00273284,18.9923992 C2.45052752,18.9923992 2.00287667,18.5711119 2.00287667,18.0191769 C2.00287667,17.8254766 -0.0922748559,8.1786463 0.0031643386,8.025511 C0.0031643386,7.44743167 0.450815195,7 1.0030205,7 L21.0001438,7 Z"
      />
    </g>
  </IconBase>
)

export const DiscussIcon: React.FC = () => (
  <IconBase>
    <g fill="none" fillRule="evenodd" transform="translate(6 9)">
      <path
        className={styles.sidebar__iconPrimary}
        d="M17.4996294,16.663763 C18.0888876,16.663763 18.6596157,16.5869764 19.2029192,16.4446954 L21.5688466,18 L21.1760078,15.5548744 C22.88078,14.4121095 24,12.4992203 24,10.3318815 C24,6.83508093 21.0900279,4 17.4996294,4 C13.9099721,4 11,6.83508093 11,10.3318815 C11.0007412,13.8294349 13.9099721,16.663763 17.4996294,16.663763 Z"
      />
      <path
        className={styles.sidebar__iconSecondary}
        d="M8.00118968,15.3776593 C7.27532328,15.3776593 6.57325577,15.2846589 5.90450672,15.1105812 L3,17 L3.47543248,14.0295507 C1.37636963,12.6440829 0,10.321457 0,7.6888297 C0,3.44181045 3.58252752,0 8.00039638,0 C12.4182652,0 15.9999995,3.44181045 15.9999995,7.6888297 C16.0015861,11.9342591 12.4198518,15.3776593 8.00118968,15.3776593 Z"
      />
      <path
        className={styles.sidebar__iconPrimary}
        d="M4.99950174 9C4.44743398 9 4 9.4480249 4 10 4 10.5530146 4.44743398 11 4.99950174 11 5.55256602 11 6 10.5530146 6 10 6 9.4480249 5.55256602 9 4.99950174 9zM7.99950174 9C7.44743398 9 7 9.4480249 7 10 7 10.5530146 7.44743398 11 7.99950174 11 8.55256602 11 9 10.5530146 9 10 9 9.4480249 8.55256602 9 7.99950174 9zM10.9995017 9C10.447434 9 10 9.4480249 10 10 10 10.5530146 10.447434 11 10.9995017 11 11.552566 11 12 10.5530146 12 10 12 9.4480249 11.552566 9 10.9995017 9z"
      />
    </g>
  </IconBase>
)

export const LearnIcon: React.FC = () => (
  <IconBase>
    <g fill="none" fillRule="evenodd" transform="translate(6 6)">
      <path
        className={styles.sidebar__iconSecondary}
        d="M16.650032,11.8650347 C18.0379355,10.5271356 19.6324317,8.98518907 20.9425192,7.71374099 C21.589536,8.26401745 22,9.08407422 22,10 C22,11.6568542 20.6568542,13 19,13 C18.0480252,13 17.1996144,12.5565901 16.650032,11.8650347 Z"
      />
      <path
        className={styles.sidebar__iconPrimary}
        d="M10.7450747,9.48875 C10.7450747,8.37075 11.0250747,7.32675 11.4840747,6.38475 L10.3860747,5.28775 L3.71607468,11.95875 C4.95607468,12.93475 4.83107468,13.88875 3.38007468,14.81875 L12.2910747,21.72875 L16.6580747,21.72875 C17.2200747,21.72875 17.6760747,22.18475 17.6760747,22.74675 L17.6760747,23.76475 L12.9080747,23.76475 L5.46807468,23.76475 L5.46807468,22.74775 C5.46807468,22.18575 5.92407468,21.72975 6.48607468,21.72975 L10.8530747,21.72975 L2.44707468,15.32475 C0.786074681,16.03675 -0.0339253185,15.34875 0.00107468148,13.23475 C0.0390746815,10.98575 0.992074681,10.38575 2.84007468,11.39775 L9.66907468,4.56875 L8.99307468,3.89375 C8.59607468,3.49775 8.59607468,2.85275 8.99307468,2.45575 L11.1510747,0.29775 C11.5480747,-0.09925 12.1930747,-0.09925 12.5900747,0.29775 L15.1900747,2.89975 C16.0180747,2.56275 16.9190747,2.36975 17.8680747,2.36975 C20.2100747,2.36975 22.2900747,3.37475 23.5870747,5.12175 C23.6310747,5.13275 13.4000747,15.02175 13.3630747,15.00575 C11.7650747,13.69975 10.7450747,11.71375 10.7450747,9.48875 Z"
      />
    </g>
  </IconBase>
)
